import Phaser from "phaser";
import { GardenScene } from "./scenes/GardenScene";
import "./styles/main.css";

const canvasParent = document.querySelector<HTMLDivElement>("#game-canvas");

if (!canvasParent) {
  throw new Error("Missing #game-canvas mount point");
}

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: canvasParent,
  width: 1024,
  height: 640,
  backgroundColor: "#94d9af",
  pixelArt: false,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  physics: {
    default: "arcade",
    arcade: {
      debug: false
    }
  },
  scene: [GardenScene]
};

new Phaser.Game(config);
